<template>
  <el-autocomplete
    class="auto_complete"
    size="small"
    :value="value"
    v-model="shopname"
    :fetch-suggestions="querySearchAsync"
    placeholder="请输入内容"
    @select="handleSelect"
    @blur="checkblur"
    @clear='clearInput'
    clearable
  ></el-autocomplete>
</template>
<script>
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";

export default {
  props: {
    platformCode: {
      type: String
    },
    value: {
      type: String
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return { shopname: "" };
  },
  computed: {
    ...mapGetters(["getShopList"]),
    ...mapState({
      dimShopName: state => state.creditScore.dimShopName//店铺数组
    }),
  },
  mounted() {
    // this.GetListBMC();
  },
  methods: {
    ...mapActions([
      // "GetListBMC",
      "getfinShopByName"
    ]),
    clearInput(){
        this.$emit("selectShopname", {shopid:'',shoptype:'',shoptype:''});
    },
    clearData() {
      this.shopname = "";
      this.shopid=''
      this.shoptype=''
    },
    echoShopName(value){
      this.shopname=value
    },
    async querySearchAsync(queryString, cb) {
      await this.getfinShopByName({
        shopname: this.shopname,
        platform: this.platformCode
      });
      var restaurants = this.dimShopName;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(val) {
      let obj=this.getshopId();
      this.$emit("change", val.value);
      this.$emit("selectShopname", obj);
    },
    checkblur() {
      let obj=this.getshopId();
      this.$emit("selectShopname", obj);
      this.$emit("change", this.shopname);
    },
    getshopId() {
      let obj = {
        shopid: "",
        shoptype: "",
        wangwang: "",
        shopname: "",
      };
      this.dimShopName.map(item => {
        console.log(item)
        if (item.shopname || item.shopName === this.shopname) {
          obj.shopid = item.id;
          obj.shoptype = item.shoptype;
          obj.shopname=this.shopname;
          obj.platformCode=item.platformCode
          obj.wangwang = item.wangwang
        }
      });
      this.$emit("changeShopName");
      return obj
    }
  }
};
</script>
<style lang="scss">
.auto_complete {
  display: inline-block;
}
</style>
